import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  tenantApplication: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'tenant-application' }),
}

export { paths }
